/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import { useNavigate, useParams } from "react-router-dom";
// import { updateDish } from "../core/_requests";
import ListAddon from "./ListAddon";

const Availability = () => {
  const navigate = useNavigate();
  const { id, status } = useParams();
  const clickCancel = () => {
    navigate("/addons");
  };
  const yesDelete = () => {
        if (status === "true") {
      var enableDisable = false;
    } else {
      var enableDisable = true;
    }
    const data = { enableDisableStatus: enableDisable };
    // updateDish(id, data).then((res) => {
    //   navigate("/addons/");
    // });
  };
  return (
    <section className="container-fluid addContainerFluid">
      <ListAddon />
      <div className="overlay"></div>
      <div className="drawer small">
        <div className="alert-wrap">
          <img
            className="ico mb-4"
            src="/assets/images/alert-warning-ico.svg"
            alt="success"
          />
          <h1 className="mb-3">Are you sure?</h1>
          <p className="mid-gray mb-4 text-center">
            <small>
              Do you want {status == "true" ? "disable" : "enable"} this dish.
            </small>
          </p>
          <button
            className="btn btn-danger rounded-5 px-5 mt-2 mb-2"
            onClick={yesDelete}
          >
            Yes, Disable
          </button>
          <button className="btn btn-cancel rounded-5" onClick={clickCancel}>
            No, I don’t want to delete
          </button>
        </div>
      </div>{" "}
    </section>
  );
};
export default Availability;
